import {
  ColumnSettings,
  ColumnTypes,
  TableCellURLType,
  TableFilterType,
} from '@app/sharedModule/models/table-settings.model';

export const searchTableConfig: ColumnSettings[] = [
  {
    type: ColumnTypes.COLOR,
    prop: 'colorCoding',
    name: 'Color coding',
    filterValueArray: [],
    sortDirection: null,
    width: 70,
    minWidth: 70,
    maxWidth: 70,
    canBeHide: true,
    default: true,
  },
  {
    sortDirection: null,
    prop: 'orderNumber',
    name: 'Order no.',
    fraudRisk: true,
    withExchange: true,
    width: 70,
    minWidth: 70,
    pendingPayment: true,
    split: true,
    merged: true,
    canBeHide: true,
    default: true,
  },
  {
    prop: 'externalOrderNumber',
    name: 'External order number',
    type: ColumnTypes.TEXT,
    width: 50,
    minWidth: 50,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    canBeHide: true,
    default: false,
  },
  {
    prop: 'itemCount',
    name: 'Items',
    width: 70,
    minWidth: 70,
    sortDirection: null,
    default: true,
    canBeHide: false,
  },
  {
    prop: 'zone',
    name: 'Zone',
    width: 70,
    minWidth: 70,
    maxWidth: 70,
    sortDirection: null,
    default: false,
    canBeHide: true,
  },
  {
    type: ColumnTypes.DATE,
    prop: 'createdDate',
    name: 'Date ordered',
    width: 110,
    minWidth: 90,
    sortDirection: null,
    headerTitleIcon: true,
    canBeHide: true,
    default: true,
  },
  {
    prop: 'shippingAddressFormatted',
    name: 'Ship to',
    width: 180,
    minWidth: 180,
    type: ColumnTypes.POPOVER_COLUMN,
    sortDirection: null,
    withNote: true,
    sortFieldName: ['customer.ordersCount'],
    default: true,
    canBeHide: false,
    withLoyalty: true,
  },
  {
    prop: 'comment',
    name: 'PDQ Stage',
    width: 80,
    minWidth: 80,
    sortDirection: '',
    default: true,
    canBeHide: false,
  },
  {
    prop: 'deliveryPromise',
    name: 'Delivery promise',
    type: ColumnTypes.DELIVERY_PROMISE,
    width: 110,
    minWidth: 130,
    maxWidth: 260,
    filterFields: 'deliveryDate',
    sortFieldName: ['deliveryDate'],
    default: true,
  },
  {
    prop: 'merchantShippingDate',
    name: 'Ship on',
    type: ColumnTypes.DATE,
    dateFormat: 'MMM dd',
    width: 110,
    minWidth: 90,
    maxWidth: 200,
    filterFields: 'merchantShippingDate',
    sortFieldName: ['merchantShippingDate'],
    canBeHide: true,
  },
  {
    prop: 'shipFromAddress.storeName',
    name: 'Inventory location',
    width: 70,
    minWidth: 70,
    sortDirection: null,
    sortFieldName: ['shipFromAddress'],
    default: true,
    canBeHide: true,
    filterSelectOptions: [],
  },
  {
    prop: 'customerFormated',
    name: 'Bill to',
    width: 70,
    minWidth: 70,
    sortDirection: null,
    sortFieldName: ['customer'],
    default: true,
    canBeHide: true,
  },
  {
    prop: 'deliveryTransaction.shippingId',
    name: 'Tracking Number',
    width: 100,
    minWidth: 100,
    sortFieldName: ['deliveryTransaction.shippingId'],
    linkType: TableCellURLType.DELIVERY_TRACKING_URL,
    canBeHide: true,
    default: false,
  },
];
